module.exports = __webpack_public_path__ + "img/ban1.b846598e.jpg";